import { render, staticRenderFns } from "./OogDetailPop.vue?vue&type=template&id=61308be7&scoped=true"
import script from "./OogDetailPop.vue?vue&type=script&lang=js"
export * from "./OogDetailPop.vue?vue&type=script&lang=js"
import style0 from "./OogDetailPop.vue?vue&type=style&index=0&id=61308be7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61308be7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61308be7')) {
      api.createRecord('61308be7', component.options)
    } else {
      api.reload('61308be7', component.options)
    }
    module.hot.accept("./OogDetailPop.vue?vue&type=template&id=61308be7&scoped=true", function () {
      api.rerender('61308be7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/OogDetailPop.vue"
export default component.exports